import "./style.css";
const PrivacyPolicyPage = () => {
  return (
    <div className="bgPrivacyPolicy">
      <p className="headerPrivacyPolicy">Privacy Policy</p>
      <p className="textPrivacyPolicy">
        At FoodLabz, we value your trust and are committed to protecting your
        privacy. This Privacy Policy outlines how we collect, use, disclose, and
        protect your personal information when you use our platform, website,
        and mobile app for food lab testing services.
      </p>
      <p className="textPrivacyPolicy">
        By using FoodLabz, you agree to the collection and use of your personal
        information as described in this Privacy Policy.
      </p>

      <p className="headerPrivacyPolicy">1. Information We Collect</p>
      <p className="textPrivacyPolicy">
        We collect various types of information to provide and improve our
        services to you:
      </p>
      <ul>
        <li className="textPrivacyPolicy">
          <strong>Personal Information:</strong> This includes your name, email
          address, phone number, billing information, and other details
          necessary for account creation and communication.
        </li>
        <li className="textPrivacyPolicy">
          <strong>Technical Data:</strong> We may collect information such as
          your device type, operating system, IP address, browser type, and
          usage data to enhance your experience on the platform.
        </li>
        <li className="textPrivacyPolicy">
          <strong>Testing Information:</strong> Data related to the samples,
          tests conducted, results, and other lab-related information you
          provide through the platform.
        </li>
      </ul>

      <p className="headerPrivacyPolicy">2. How We Use Your Information</p>
      <p className="textPrivacyPolicy">
        We use the information we collect for the following purposes:
      </p>
      <ul>
        <li className="textPrivacyPolicy">
          To provide our services, including managing and processing food
          testing requests and results.
        </li>
        <li className="textPrivacyPolicy">
          To communicate with you regarding service updates, promotions, or
          customer support inquiries.
        </li>
        <li className="textPrivacyPolicy">
          To improve the functionality, performance, and security of our
          website, mobile app, and services.
        </li>
        <li className="textPrivacyPolicy">
          For legal and regulatory compliance.
        </li>
      </ul>

      <p className="headerPrivacyPolicy">3. Sharing Your Information</p>
      <p className="textPrivacyPolicy">
        We do not sell or share your personal information with third parties for
        marketing purposes. However, we may share your information in the
        following circumstances:
      </p>
      <ul>
        <li className="textPrivacyPolicy">
          <strong>Service Providers:</strong> We may share information with
          trusted third-party service providers to assist in delivering our
          services, including labs, logistics partners, and payment processors.
        </li>
        <li className="textPrivacyPolicy">
          <strong>Legal Compliance:</strong> We may disclose your information if
          required by law or to protect our rights, property, or safety, or that
          of others.
        </li>
      </ul>

      <p className="headerPrivacyPolicy">4. Data Security</p>
      <p className="textPrivacyPolicy">
        We implement industry-standard security measures to protect your
        information from unauthorized access, disclosure, or misuse. However, no
        method of transmission over the Internet is completely secure, and we
        cannot guarantee absolute security.
      </p>

      <p className="headerPrivacyPolicy">5. Your Rights</p>
      <p className="textPrivacyPolicy">
        You have the following rights regarding your personal information:
      </p>
      <ul>
        <li className="textPrivacyPolicy">
          <strong>Access and Correction:</strong> You may access and update your
          personal information through your account settings.
        </li>
        <li className="textPrivacyPolicy">
          <strong>Data Deletion:</strong> You may request the deletion of your
          account and personal information by contacting us at support@agnext.in
        </li>
      </ul>

      <p className="headerPrivacyPolicy">6. Changes to this Privacy Policy</p>
      <p className="textPrivacyPolicy">
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated date at the top. We encourage you to
        review this Privacy Policy periodically for any updates
      </p>

      <p className="headerPrivacyPolicy">7. Contact Us</p>
      <p className="textPrivacyPolicy">
        If you have any questions or concerns about this Privacy Policy, please
        contact us at:
      </p>
      <p className="textPrivacyPolicy">
        <strong>AgNext Technologies</strong>
        <br />
        C184, STPI Building, Sector 75, Mohali
        <br /> support@agnext.in <br />
        +91-8047185818
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;
